import type { DepictDisplay } from "./types";

export const depictFormatter = (listingDisplay: DepictDisplay) => {
  const variant = listingDisplay.variant_displays[listingDisplay.variant_index];
  return {
    displayItemId: variant.display_item_id,
  };
};
